<template>
    <div class="cover-content table-wrapper">
        <!-- <high-search> -->
        <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="100" label-position="right">
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="项目名称:" :label-width="78" prop="projectName">
                        <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目所在地:" prop="areaCode">
                        <place-select v-model="formInline.areaCode"></place-select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="所属企业:" prop="corpName">
                        <Input v-model="formInline.corpName" placeholder="请输入所属企业"></Input>
                    </FormItem>
                </Col>
                <Col span="6" class="high-search">
                    <FormItem :label-width="0">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16" v-show="open">
                <Col span="6">
                    <FormItem label="班组名称:" :label-width="78" prop="teamName">
                        <Input v-model="formInline.teamName" placeholder="请输入班组名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="工资年份:" prop="year">
                        <DatePicker type="year" placeholder="请选择工资年份" :value="formInline.year"  @on-change='formInline.year=$event'></DatePicker>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="工资月份:" prop="month">
                        <DatePicker type="month" placeholder="请选择工资月份" :value="formInline.month"  @on-change='formInline.month=$event'></DatePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="8">
                    <Button :loading="eLoading" style="margin-bottom: 24px;" icon="ios-exit-outline" type="primary" @click="handleExport">导出</Button>
                </Col>
            </Row>
        </Form>
        <!-- </high-search> -->
        <div class='cover-table'>
            <Table border style="width: 100%;" :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="attachmentList">
                    <div v-if="row.attachmentList && row.attachmentList.length">
                        <a v-for="item in row.attachmentList" :href="item.fileName" class="wage_a" target="_blank">{{item.name}}</a>
                    </div>
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('workerPayRollListT',row.id)">详情</span>
                </template>
            </Table>
            <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<script>
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                open: false,
                formInline:{
                    projectName: '',
                    areaCode: localStorage.getItem('tenantAreaCode'),// 地区
                    corpName: '',
                    teamName: '',
                    year: '',
                    month: '',
                },
                tableColumns:[
                    { title: '序号', type: 'index', width: 70, fixed: 'left', align: 'center' },
                    { title: '项目名称', key: 'projectName', minWidth: 150, tooltip: true },
                    { title: '项目所在地', key: 'areaName', minWidth: 100, tooltip: true },
                    { title: '所属企业', key: 'corpName', minWidth:100, tooltip: true },
                    { title: '班组名称', key: 'teamName', minWidth: 100, tooltip: true },
                    { title: '工资月份', key: 'payMonth', minWidth: 100, tooltip: true },
                    { title: '工资单附件', slot: 'attachmentList', minWidth: 150 },
                    { title: '操作', slot: 'action', fixed: 'right', align: 'center', minWidth:100 }
                ],
                tableData: [],
            };

        },
        computed:{
        },
        created(){

        },
        mounted(){

        },
        watch: {

        },
        methods: {
            disabledDateStart(val) {
                return val.getTime() > (Date.now() - 86400000);
            },
            handleReset() {  
                this.pageSize = 10;
                this.page = 1;
                this.formInline.projectName = ''
                this.formInline.corpName = ''
                this.formInline.year = ''
                this.formInline.month = ''
                this.formInline.teamName = ''        
                this.formInline.areaCode = localStorage.getItem('tenantAreaCode');
                this.getTableData()
            },
            // 导出
            handleExport(){
                const params = {
                    size: this.pageSize,
                    current: this.page,
                };
                Object.assign(params, this.formInline);
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/summary/sx/payOff/export',
                    responseType:'arraybuffer',
                    data: params,
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'工人工资.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name, id){
                this.$router.push({
                    name: name,
                    params: {
                        id
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                const params = {
                    size: this.pageSize,
                    current: this.page,
                };
                Object.assign(params, this.formInline);
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/summary/sx/payOff/pageList',
                    data: params
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total
                        this.tableData = response.data.data.records
                    }
                }).catch(()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped>
    .wage_a{
        display: inline-block;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap
    }
</style>
